<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/logo.png"
              alt="PetFish - logo" />
          </h1>
          <d-alert
            v-if="authError"
            theme="danger"
            show>
            Invalid 2FA code. Please try again.
          </d-alert>
          <form @submit.prevent="loginWith2fa">
            <div class="form-group">
              <label>
                <span>2FA Code:</span>
              </label>
              <d-input
                v-model="code"
                name="code"
                type="number"
                :class="{'is-invalid' : larErrors.has('email')}"
                placeholder="" />
              <div class="invalid-feedback" v-text="larErrors.get('email')"></div>
            </div>
            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="loginWith2fa"
              :disabled="submitting">
              <template v-if="!submitting">Log in</template>
              <template v-else>Logging in&hellip;</template>
            </button>
          </form>
        </div>

        <div class="card-footer text-center">
          <router-link to="/login">
            Back to login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LarErrors from '../utils/Errors';

export default {
  name: 'LoginTwoFactor',
  components: {
    LarErrors
  },
  data () {
    return {
      authError: false,
      submitting: false,
      larErrors: LarErrors,
      code: ''
    }
  },
  methods: {
    loginWith2fa () {
      this.authError = false;
      this.submitting = true;
      this.$http.post('/auth/login-2fa', {
        code: this.code,
        token: this.$route.params.token
      }).then((response) => {
        this.submitting = false;

        if (response.data.access_token) {
          window.localStorage.setItem('token', response.data.access_token);
          window.localStorage.setItem('last-token-refresh', +new Date());
          this.$root.userLoggedIn = true;
          this.$http.defaults.headers['Authorization'] = `Bearer ${response.data.access_token}`;
          this.$nextTick(() => {
            if (response.data.must_change_password) {
              this.$router.push('/dashboard/change-password/force');
              return;
            }

            let potentialRedirect = window.crmGetRedirect();

            if (potentialRedirect) {
              this.$router.push(potentialRedirect);
            } else {
              this.$router.push('/dashboard');
            }
          });
        } else {
          this.authError = true;
          this.code = '';
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>

<style scoped>
label {
  align-items: flex-end;
  display: block;

  & > span {
    display: inline-block;
  }
}
</style>
